import { appConfig, headerConfig, refineHeader } from "../../config";

export const designCenterService = {
  getAllAssets,
  addAsset,
  deleteAsset,
  getAssetDetail,
  updateAsset,
  getAllAssetsColor,
  updateAssetColor,
  getAssetColorDetail,
  addAssetColor,
  getThemeData, 
  getCustomPage,
  CustomPageCreate,
  CustomPageUpdate,
  CustomPageDelete,
  CustomDataByURL,
};

function addAsset(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: formData
  };
  return fetch(`${appConfig.api.url}design/assets/create`, requestOptions)
    .then(handleResponse)
    .then(asset => {
      return asset;
    });
}

function addAssetColor(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: formData
  };
  return fetch(`${appConfig.api.url}design/colors/create`, requestOptions)
    .then(handleResponse)
    .then(assetColor => {
      return assetColor;
    });
}

function updateAsset(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: formData
  };

  return fetch(`${appConfig.api.url}design/assets/edit`, requestOptions)
    .then(handleResponse)
    .then(asset => {
      return asset;
    });
}

function updateAssetColor(formData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}design/colors/edit`, requestOptions)
    .then(handleResponse)
    .then(assetColor => {
      return assetColor;
    });
}

function getAllAssets(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}design/assets/list`, requestOptions)
    .then(handleResponse)
    .then(allassets => {
      return allassets;
    });
}

function getAllAssetsColor(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}design/colors/list`, requestOptions)
    .then(handleResponse)
    .then(allAssetsColor => {
      return allAssetsColor;
    });
}

function deleteAsset(assetID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas
  };

  return fetch(`${appConfig.api.url}design/delete/${assetID}`, requestOptions)
    .then(handleResponse)
    .then(asset => {
      return asset;
    });
}

function getAssetDetail(assetID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas
  };

  return fetch(
    `${appConfig.api.url}design/assets/detail/${assetID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(asset => {
      return asset;
    });
}

function getAssetColorDetail(assetID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas
  };

  return fetch(
    `${appConfig.api.url}design/colors/detail/${assetID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(assetColor => {
      return assetColor;
    });
}

function getThemeData(formData) {
  refineHeader();

  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}design/properties`, requestOptions)
    .then(handleResponse)
    .then(themeData => {
      return themeData;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}


function getCustomPage(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}design/custompage/list`, requestOptions)
    .then(handleResponse)
    .then(allassets => {
      return allassets;
    });
}

function CustomDataByURL(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };
  return fetch(`${appConfig.api.url}design/custompage/front`, requestOptions)
    .then(handleResponse)
    .then(allassets => {
      return allassets;
    });
}


function CustomPageCreate(formData) {
  refineHeader(); 
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}design/custompage/create`, requestOptions)
    .then(handleResponse)
    .then(data => { 
      return data;
    });
}



function CustomPageUpdate(formData) {
  refineHeader(); 
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}design/custompage/update`, requestOptions)
    .then(handleResponse)
    .then(data => { 
      return data;
    });
}

function CustomPageDelete(assetID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas
  };

  return fetch(`${appConfig.api.url}design/custompage/delete/${assetID}`, requestOptions)
    .then(handleResponse)
    .then(data => { 
      return data;
    });
}


// WEBPACK FOOTER //
// ./src/app/services/API/designCenterService.js